module.exports = __webpack_public_path__ + "img/productinfo-1.972f8561.jpg";